module.exports = __webpack_public_path__ + "img/elevator-preview.ab882bf1.webp";